import axios from "axios";
import { toast } from "../../../components/toastNotification";
import {
  ICarrierContactPerState,
  ICarrierFiles,
  ICarriers,
  INSAContacts,
  INationalContacts,
  ISPLCContacts,
  ICarrierMetricsPerState,
  ICarrierStateAppointed,
} from "../../../modules/CarrierAgreementMgmt/Carrier/types";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getCarriers = async () => {
  try {
    const data = await axios.get<ICarriers[]>(`${api_base_url}/Carriers`);
    if (data.status === 200) {
      return data.data;
    } else {
      toast.fire(
        "Warning",
        "Cannot retrieve Carrier data, please check connection or contact your admin",
        "error"
      );
      return [];
    }
  } catch (error) {
    throw new Error("Server Error");
  }
};

export const downloadSourceFile = async (file) => {
  var response = await axios.get(
    `${api_base_url}/Carriers/DownloadSourceFile?fileName=${file}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    }
  );
  return response;
};

export const getCarrierContacts = async (masterCarrierId) => {
  if (masterCarrierId.queryKey[1].masterCarrierId) {
    const { data } = await axios.get(
      `${api_base_url}/Carriers/ContactList/${masterCarrierId.queryKey[1].masterCarrierId}`
    );
    return data;
  }
};
const appendParameters = (data) => {
  const formData = new FormData();
  data.masterCarrierId &&
    formData.append("masterCarrierId", data.masterCarrierId);
  data.carrierName && formData.append("carrierName", data.carrierName);
  data.fein && formData.append("fein", data.fein);
  data.naic && formData.append("naic", data.naic);
  data.amBestRating && formData.append("amBestRating", data.amBestRating);
  data.dateOfAmBestRating &&
    formData.append("dateOfAmBestRating", data.dateOfAmBestRating);
  data.isActive !== null && formData.append("isActive", data.isActive);
  data.isFranchise && formData.append("isFranchise", data.isFranchise);
  data.isDigitized && formData.append("isDigitized", data.isDigitized);
  data.states && data.states?.map((x) => formData.append("stateIds", x.value));
  data.masterCarrierDetails &&
    data.masterCarrierDetails.masterCarrierAddress &&
    formData.append(
      "MasterCarrierDetails.masterCarrierAddress",
      data.masterCarrierDetails.masterCarrierAddress
    );
  data.phoneTypeId && formData.append("phoneTypeId", data.phoneTypeId);
  data.masterCarrierDetails &&
    data.masterCarrierDetails.nsa != null &&
    formData.append("MasterCarrierDetails.nsa", data.masterCarrierDetails.nsa);
  data.masterCarrierDetails &&
    data.masterCarrierDetails.splc != null &&
    formData.append(
      "MasterCarrierDetails.splc",
      data.masterCarrierDetails.splc
    );
  data.masterCarrierDetails &&
    data.masterCarrierDetails.alias &&
    formData.append(
      "MasterCarrierDetails.alias",
      data.masterCarrierDetails.alias
    );
  data.nationalContacts?.forEach((obj: INationalContacts, i: number) =>
    Object.entries(obj)?.forEach(([key, value]) => {
      if (value) {
        formData.append(`NationalContactsDto[${i}].${key}`, value);
      }
    })
  );
  data.nsaContacts?.forEach((obj: INSAContacts, i: number) =>
    Object.entries(obj)?.forEach(([key, value]) => {
      if (value) {
        formData.append(`NsaContactsDto[${i}].${key}`, value);
      }
    })
  );
  data.splcContacts?.forEach((obj: ISPLCContacts, i: number) =>
    Object.entries(obj)?.forEach(([key, value]) => {
      if (value) {
        formData.append(`SplcContactsDto[${i}].${key}`, value);
      }
    })
  );
  data.carrierContactPerState?.forEach(
    (obj: ICarrierContactPerState, i: number) =>
      Object.entries(obj)?.forEach(([key, value]) => {
        if (value) {
          formData.append(`CarrierContactPerStateDto[${i}].${key}`, value);
        }
      })
  );
  data.carrierMetricsPerState?.forEach(
    (obj: ICarrierMetricsPerState, i: number) =>
      Object.entries(obj)?.forEach(([key, value]) => {
        if (value) {
          formData.append(`CarrierMetricsPerState[${i}].${key}`, value);
        }
      })
  );
  data.carrierStateAppointed?.forEach(
    (obj: ICarrierStateAppointed, i: number) =>
      Object.entries(obj)?.forEach(([key, value]) => {
        if (value) {
          formData.append(`CarrierStateAppointed[${i}].${key}`, value);
        }
      })
  );
  data.attachments &&
    data.attachments?.map((x) => formData.append("attachments", x));
  data.carrierFiles?.forEach((obj: ICarrierFiles, i: number) =>
    Object.entries(obj)?.forEach(([key, value]) => {
      formData.append(`CarrierFilesDto[${i}].${key}`, value);
      formData.append(
        `CarrierFilesDto[${i}].modifiedDate`,
        new Date().toISOString()
      );
    })
  );
  return formData;
};
//Insert New Carrier
export const addCarrier = async (data) => {
  const appendedData = appendParameters(data);
  return await axios.post(`${api_base_url}/Carriers`, appendedData);
};

// Update Carrier
export const updateCarrier = async (data) => {
    const appendedData = appendParameters(data);
    return await axios.put(`${api_base_url}/Carriers`, appendedData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

//Get Active Carrier Name List
export const getCarrierNameList = async () => {
  const { data } = await axios.get(`${api_base_url}/Carriers/carrierNameList`);
  return data;
};

export const validateCarrierMassUpload = (data) => {
  return axios.post(`${api_base_url}/carriers/validate/`, data).then((res) => {
    if (res.status === 400) {
      res.data.json();
    }
    return res.data;
  });
};

export const validateCarrierContactMassUpload = (data) => {
  return axios
    .post(`${api_base_url}/carriers/validateContact/`, data)
    .then((res) => {
      if (res.status === 400) {
        res.data.json();
      }
      return res.data;
    });
};

export const massUploadCarrier = (data) => {
  return axios
    .post(`${api_base_url}/carriers/mass-upload/`, data)
    .then((res) => {
      return res;
    });
};

export const downloadCarrierTemplate = async (isForMassUploadCarrier) => {
  var response = await axios.get(
    `${api_base_url}/carriers/download/template/${isForMassUploadCarrier}`,
    {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};

export const getCarriersCount = async () => {
  const data = await axios.get<ICarriers[]>(
    `${api_base_url}/Carriers/CarriersCount`
  );
  return data.data;
};

//Get phone type name
export const getCarrierPhoneType = async () => {
  const { data } = await axios.get(`${api_base_url}/Carriers/carrierPhoneType`);
  return data;
};

export const getCarrierEAndOSubmissionType = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Carriers/carrierEAndOSubmissionType`
  );
  return data;
};

export const getAMBestRating = () => {
  return axios.get(`${api_base_url}/Carriers/AMBestRating`).then((res) => {
    return res.data;
  });
};

export const getCarrierContacTypes = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Carriers/CarrierContactTypes`
  );
  return data;
};

export const getAllCarriers = async () => {
  try {
    const data = await axios.get(`${api_base_url}/Carriers/GetAllCarriers`);
    return data.data;
  } catch (error) {
    throw new Error("Server Error");
  }
};

export const getCarrierForEdit = async (id) => {
  return await axios
    .get(`${api_base_url}/Carriers/ForEdit/${id}`)
    .then((res) => {
      return res.data;
    });
};

export const getIdsForCarrierDownload = (ids) => {
  return axios
    .post(`${api_base_url}/Carriers/forCarrierDownload`, ids)
    .then((res) => res.data);
};
